import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const topicsApi = apiResourceBuilder({
  name: 'cuss/topicsofconcern',
  idResolver: ({ key }) => key,
});

export const topicsSchema = new schema.Entity(
  'topics',
  {},
  { idAttribute: 'key' }
);

export default entityActionCreator({ schema: topicsSchema, api: topicsApi });



// WEBPACK FOOTER //
// ./src/App/account/actions/customers/topics.js